import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { NavCollapsableComponent } from './nav-collapsable/nav-collapsable.component';
import { NavGroupComponent } from './nav-group/nav-group.component';
import { NavItemComponent } from './nav-item/nav-item.component';
import { NavigationComponent } from './navigation.component';
import { TenantSelectorComponent } from './tenant-selector/tenant-selector.component';

@NgModule({
  imports: [
    CommonModule,

    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatRippleModule,
    ReactiveFormsModule,
    NavigationComponent,
    NavGroupComponent,
    NavItemComponent,
    NavCollapsableComponent,
    TenantSelectorComponent,
  ],
  exports: [NavigationComponent],
})
export class NavigationModule {}
